import { Component } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import swal from "sweetalert2";

@Component({
  selector: 'forgotten-password',
  templateUrl: './forgotten-password.component.html',
  host: { 'class': 'login-main' }
})
export class ForgottenPasswordComponent {

  form: UntypedFormGroup;
  submitting: boolean;
  submitted: boolean;


  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private authService: AuthService
  ) {
    this.form = fb.group({
      'email': [null, Validators.compose([Validators.required, Validators.email])]
    })
  }

  submit(form: UntypedFormGroup): void {
    this.submitted = true;
    if (form.invalid) return;
    this.submitting = true;

    this.authService.requestResetPassword(form.value.email).then(success => {
      this.router.navigate(['/auth/forgotten-password/sent']);
    }, error => {
      this.submitting = false;

      swal(
        'Error',
        error.description ? error.description : 'Please try again',
        'error'
      );
    });
  }

}
